<template>
  <ul :class="`button-list ${classes}`">
    <DefaultButton
      v-for="(button, index) in items"
      :key="index"
      :label="button.label"
      labelClass="text-uppercase"
      buttonClass="button-large"
      type="popup"
      @pressed="onPressed(button)"
    />
  </ul>
</template>

<script>
import DefaultButton from '../partials/DefaultButton'

export default {
  name: 'PopupImageList',
  components: {
    DefaultButton,
  },
  props: {
    classes: {
      type: String,
      required: false,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    }
  },
  methods: {
    onPressed(event) {
      this.$emit('action', event);
    }
  },
}
</script>
